module.exports = __webpack_public_path__ + "img/heliceFundo.db471bc6.svg";